const FORM_CONTROL_KEY = /* @__PURE__ */ Symbol("FORM_CONTROL_KEY");
export {
  FORM_CONTROL_KEY
};
//# sourceMappingURL=type.js.map
